(function () {
  'use strict';

  /* Shared product-page scope plus explicit per-section opt-in. No product-id allowlist. */
  var OPT_IN_ATTR = 'data-hh-pdp-chat-adapter';
  var MOBILE_QUERY = '(max-width: 749px)';
  var STYLE_ID = 'hh-pdp-chat-compact-style';
  var COMPACT_ATTR = 'data-hh-pdp-chat-compact';
  var TEASER_ATTR = 'data-hh-pdp-chat-teaser-hidden';
  var A11Y_ATTR = 'data-hh-pdp-chat-a11y';
  var DEFAULT_LABEL = 'Open supplement advisor';
  var PAGE_ATTR = 'data-hh-chat-page';

  /* 56px avatar + the app's own 10.6px padding on each side, rounded up. */
  var COMPACT_WIDTH = 88;
  var MIN_TARGET = 44;

  var HOST_CSS =
    'iframe[' + COMPACT_ATTR + ']{' +
    'width:' + COMPACT_WIDTH + 'px !important;' +
    'min-width:0 !important;' +
    'max-width:' + COMPACT_WIDTH + 'px !important;' +
    '}' +
    '@media ' + MOBILE_QUERY + '{' +
    'body.template-product[' + PAGE_ATTR + '="product"] iframe[' + COMPACT_ATTR + ']{' +
    'height:88px !important;min-height:0 !important;max-height:88px !important;' +
    'left:auto !important;right:16px !important;' +
    'bottom:calc(50px + env(safe-area-inset-bottom, 0px)) !important;' +
    'transition:none !important;' +
    '}' +
    'body.template-index[' + PAGE_ATTR + '="index"] iframe[' + COMPACT_ATTR + ']{' +
    'transform:scale(0.8) !important;' +
    'transform-origin:bottom right !important;' +
    'right:12px !important;' +
    'bottom:calc(12px + env(safe-area-inset-bottom, 0px)) !important;' +
    '}' +
    '}';

  var FRAME_CSS =
    '[data-testid="bikCtaContainer"][' + A11Y_ATTR + ']{' +
    'min-width:' + MIN_TARGET + 'px !important;' +
    'min-height:' + MIN_TARGET + 'px !important;' +
    '}';

  var WATCHED_ATTRS = ['style', 'class', 'aria-hidden', 'hidden'];

  function hasAccessibleLabel(el) {
    if (!el || !el.getAttribute) return false;
    var label = el.getAttribute('aria-label');
    if (label && label.trim()) return true;
    if (el.getAttribute('aria-labelledby')) return true;
    var title = el.getAttribute('title');
    if (title && title.trim()) return true;
    var txt = typeof el.textContent === 'string' ? el.textContent : '';
    return txt.trim().length > 0;
  }

  function ensureStyle(doc, id, css) {
    if (!doc) return null;
    var head = doc.head || doc.documentElement;
    if (!head) return null;
    var existing = doc.getElementById(id);
    if (existing) return existing;
    var style = doc.createElement('style');
    style.id = id;
    style.textContent = css;
    head.appendChild(style);
    return style;
  }

  function removeStyle(doc, id) {
    if (!doc) return;
    var style = null;
    try {
      style = doc.getElementById(id);
    } catch (e) {
      return;
    }
    if (style && style.parentNode) style.parentNode.removeChild(style);
  }

  /* ---- product scope (explicit opt-in only) ------------------------- */

  function findOptedInRoot(doc) {
    var roots = doc.querySelectorAll('[data-hh-pdp][' + OPT_IN_ATTR + ']');
    for (var i = 0; i < roots.length; i++) {
      var flag = String(roots[i].getAttribute(OPT_IN_ATTR) || '').trim();
      /* Strict "true" only: an absent, empty, "false" or any other value
         fails closed, exactly like the Liquid-side default. */
      if (flag === 'true') return roots[i];
    }
    return null;
  }

  var PAGE_SCOPES = ['index', 'collection', 'product'];
  var HOST_WATCHED_ATTRS = [PAGE_ATTR, 'class'];

  function isScopedBody(el) {
    if (!el || !el.getAttribute || !el.classList) return false;
    var ownerDoc = el.ownerDocument;
    if (!ownerDoc || el !== ownerDoc.body) return false;
    var value = String(el.getAttribute(PAGE_ATTR) || '').trim();
    for (var i = 0; i < PAGE_SCOPES.length; i++) {
      if (value === PAGE_SCOPES[i]) {
        return el.classList.contains('template-' + PAGE_SCOPES[i]);
      }
    }
    return false;
  }

  function findScopedBody(doc) {
    return isScopedBody(doc.body) ? doc.body : null;
  }

  function pageScopeOf(el) {
    if (!isScopedBody(el)) return null;
    return String(el.getAttribute(PAGE_ATTR) || '').trim();
  }

  function labelFor(root) {
    if (root && root.getAttribute) {
      var attr = root.getAttribute('data-hh-chat-label');
      if (attr && attr.trim()) return attr.trim();
    }
    return DEFAULT_LABEL;
  }

  /* ---- app markup recognition --------------------------------------- */

  function sameOriginDoc(iframe) {
    try {
      var doc = iframe.contentDocument;
      if (!doc || !doc.body) return null;
      void doc.documentElement;
      return doc;
    } catch (e) {
      return null;
    }
  }

  /* Open when the app has added its chat window. The #widgetOpen hash is
   * intentionally never consulted. */
  function isOpen(frameDoc) {
    try {
      if (frameDoc.querySelector('.chatbot-wrapper')) return true;
      if (frameDoc.querySelector('#bikChatWindowWrapper')) return true;
    } catch (e) {
      return false;
    }
    return false;
  }

  function elementChildren(el) {
    var out = [];
    for (var i = 0; i < el.children.length; i++) {
      var child = el.children[i];
      if (child.tagName && child.tagName.toLowerCase() === 'style') continue;
      out.push(child);
    }
    return out;
  }

  var ENTRY_WRAPPER_SELECTOR = '[data-testid="entry-point-mobile-wrapper"]';
  var ENTRY_DRAGGER_SELECTOR = '[data-testid="entry-point-mobile-dragger"]';
  var ENTRY_CLOSE_SELECTOR = '[data-testid="close-ep"]';
  var ENTRY_BUTTON_SELECTOR = 'button.entry-point-btn';
  var ENTRY_TYPE = 'TEXT';
  var ENTRY_FLOW = 'DISENGAGED_ON_THE_COLLECTION_PAGE';
  var ENTRY_SCOPES = ['collection', 'product'];

  function isEmptyDiv(el) {
    if (!el || !el.tagName || el.tagName.toLowerCase() !== 'div') return false;
    if (!el.children || el.children.length !== 0) return false;
    var txt = typeof el.textContent === 'string' ? el.textContent : '';
    return txt.trim().length === 0;
  }

  function recognizeProactive(wrapper, entry, pageScope) {
    if (!pageScope || ENTRY_SCOPES.indexOf(pageScope) === -1) return null;
    if (!entry || !entry.matches || !entry.matches(ENTRY_WRAPPER_SELECTOR)) return null;
    if (String(entry.getAttribute('data-entry-type') || '') !== ENTRY_TYPE) return null;
    if (String(entry.getAttribute('data-flow-id') || '') !== ENTRY_FLOW) return null;
    if (!entry.querySelector(ENTRY_DRAGGER_SELECTOR)) return null;
    if (!entry.querySelector(ENTRY_BUTTON_SELECTOR)) return null;
    if (entry.querySelector('[data-testid="bikCtaButton"]')) return null;
    if (entry.querySelector('[data-testid="bikCtaContainer"]')) return null;
    var close = entry.querySelector(ENTRY_CLOSE_SELECTOR);
    if (!close || typeof close.click !== 'function') return null;
    return { proactive: true, wrapper: wrapper, entry: entry, close: close };
  }

  /* Returns the recognized closed-launcher parts, or null. */
  function recognizeClosed(frameDoc, pageScope) {
    var content = frameDoc.querySelector('.frame-content');
    if (!content) return null;
    if (isOpen(frameDoc)) return null;

    var children = elementChildren(content);
    if (children.length !== 1) return null;

    var wrapper = children[0];
    if (wrapper.id !== 'bikCTAWrapper') return null;

    var wrapperChildren = elementChildren(wrapper);
    if (wrapperChildren.length === 1) {
      if (!pageScope) return null;
      return recognizeProactive(wrapper, wrapperChildren[0], pageScope);
    }
    if (wrapperChildren.length !== 2) return null;

    var avatarContainer = wrapperChildren[0];
    var teaserAncestor = wrapperChildren[1];
    if (!avatarContainer.matches || !avatarContainer.matches('[data-testid="bikCtaContainer"]')) {
      return null;
    }
    if (!avatarContainer.querySelector('[data-testid="bikCtaButton"]')) return null;
    if (teaserAncestor.querySelector('[data-testid="bikCtaContainer"]')) return null;
    if (!teaserAncestor.querySelector('[data-testid="chat-with-us-close"]')) {
      if (!pageScope || !isEmptyDiv(teaserAncestor)) return null;
      return {
        wrapper: wrapper,
        avatarContainer: avatarContainer,
        teaserAncestor: null
      };
    }

    return {
      wrapper: wrapper,
      avatarContainer: avatarContainer,
      teaserAncestor: teaserAncestor
    };
  }

  /* ---- adapter ------------------------------------------------------ */

  function create(win) {
    var doc = win.document;
    var root = null;
    var rootMode = null;
    var label = DEFAULT_LABEL;
    var mql = null;
    var hostObserver = null;
    var rafId = 0;
    var destroyed = false;
    var frames = [];

    function findRecord(iframe) {
      for (var i = 0; i < frames.length; i++) {
        if (frames[i].iframe === iframe) return frames[i];
      }
      return null;
    }

    function frameRecord(iframe) {
      var rec = findRecord(iframe);
      if (rec) return rec;
      rec = {
        iframe: iframe,
        doc: null,
        observedTarget: null,
        observer: null,
        onLoad: null,
        teaser: null,
        a11y: null
      };
      rec.onLoad = function () {
        if (destroyed) return;
        var nextDoc = sameOriginDoc(iframe);
        var nextTarget = nextDoc ? nextDoc.documentElement || nextDoc.body : null;
        if (rec.observedTarget && nextTarget !== rec.observedTarget) {
          releaseReplacedDocument(rec);
        }
        onFrameMutation();
        schedule();
      };
      iframe.addEventListener('load', rec.onLoad);
      frames.push(rec);
      return rec;
    }

    function schedule() {
      if (destroyed || rafId) return;
      var raf = win.requestAnimationFrame;
      if (typeof raf !== 'function') {
        sync();
        return;
      }
      rafId = raf.call(win, function () {
        rafId = 0;
        sync();
      });
    }

    function isMobile() {
      return !!(mql && mql.matches);
    }

    /* -- teaser: adapter-owned display + aria-hidden, exactly restorable -- */

    function hideTeaser(rec, teaser) {
      if (rec.teaser && rec.teaser.el !== teaser) releaseTeaser(rec);
      if (!rec.teaser) {
        var priority = '';
        if (teaser.style && typeof teaser.style.getPropertyPriority === 'function') {
          priority = teaser.style.getPropertyPriority('display') || '';
        }
        rec.teaser = {
          el: teaser,
          display: teaser.style ? teaser.style.display : '',
          priority: priority,
          ariaHidden: teaser.getAttribute('aria-hidden')
        };
        teaser.setAttribute(TEASER_ATTR, '1');
      }
      /* Reassert only adapter-owned state, and only when it differs, so the
       * mutation our own write triggers finds nothing to do. */
      if (teaser.style && teaser.style.display !== 'none') {
        teaser.style.setProperty('display', 'none', 'important');
      }
      if (teaser.getAttribute('aria-hidden') !== 'true') {
        teaser.setAttribute('aria-hidden', 'true');
      }
    }

    function releaseTeaser(rec) {
      var saved = rec.teaser;
      if (!saved) return;
      rec.teaser = null;
      var el = saved.el;
      if (!el) return;
      if (el.style && typeof el.style.setProperty === 'function') {
        el.style.removeProperty('display');
        if (saved.display) {
          el.style.setProperty('display', saved.display, saved.priority || '');
        }
      } else if (el.style) {
        el.style.display = saved.display || '';
      }
      if (saved.ariaHidden === null) el.removeAttribute('aria-hidden');
      else el.setAttribute('aria-hidden', saved.ariaHidden);
      el.removeAttribute(TEASER_ATTR);
    }

    /* -- accessibility on the existing launcher -- */

    function onKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
      var container = event.currentTarget;
      if (!container) return;
      var button = container.querySelector('[data-testid="bikCtaButton"]');
      if (!button || typeof button.click !== 'function') return;
      event.preventDefault();
      button.click();
    }

    function applyA11y(rec, container) {
      if (rec.a11y && rec.a11y.el !== container) releaseA11y(rec);
      if (rec.a11y) return;
      var saved = {
        el: container,
        role: container.getAttribute('role'),
        tabindex: container.getAttribute('tabindex'),
        ariaLabel: container.getAttribute('aria-label')
      };
      if (saved.role === null) container.setAttribute('role', 'button');
      if (saved.tabindex === null) container.setAttribute('tabindex', '0');
      if (!hasAccessibleLabel(container)) container.setAttribute('aria-label', label);
      container.setAttribute(A11Y_ATTR, '1');
      container.addEventListener('keydown', onKeydown);
      rec.a11y = saved;
    }

    function releaseA11y(rec) {
      var saved = rec.a11y;
      if (!saved) return;
      rec.a11y = null;
      var el = saved.el;
      if (!el) return;
      el.removeEventListener('keydown', onKeydown);
      if (saved.role === null) el.removeAttribute('role');
      else el.setAttribute('role', saved.role);
      if (saved.tabindex === null) el.removeAttribute('tabindex');
      else el.setAttribute('tabindex', saved.tabindex);
      if (saved.ariaLabel === null) el.removeAttribute('aria-label');
      else el.setAttribute('aria-label', saved.ariaLabel);
      el.removeAttribute(A11Y_ATTR);
    }

    function setCompact(iframe, on) {
      var has = iframe.hasAttribute(COMPACT_ATTR);
      if (on && !has) iframe.setAttribute(COMPACT_ATTR, '1');
      else if (!on && has) iframe.removeAttribute(COMPACT_ATTR);
    }

    function scopeToken() {
      if (rootMode === 'page') return pageScopeOf(root);
      if (rootMode === 'product') return 'product';
      return null;
    }

    var dismissedSet = typeof win.WeakSet === 'function' ? new win.WeakSet() : null;
    var dismissedList = [];

    function wasDismissed(el) {
      if (dismissedSet) return dismissedSet.has(el);
      return dismissedList.indexOf(el) !== -1;
    }

    function markDismissed(el) {
      if (dismissedSet) {
        dismissedSet.add(el);
        return;
      }
      if (dismissedList.indexOf(el) === -1) dismissedList.push(el);
    }

    function dismissProactive(parts) {
      var close = parts.close;
      var entry = parts.entry;
      if (!close || wasDismissed(close) || wasDismissed(entry)) return;
      markDismissed(close);
      markDismissed(entry);
      try {
        close.click();
      } catch (e) {}
    }

    /* Release everything this record owns, restoring the recorded originals.
     * Safe on detached nodes from a replaced document. */
    function releaseFrameState(rec) {
      releaseTeaser(rec);
      releaseA11y(rec);
      setCompact(rec.iframe, false);
      if (rec.doc) removeStyle(rec.doc, STYLE_ID);
    }

    function releaseReplacedDocument(rec) {
      if (rec.observer) {
        rec.observer.disconnect();
        rec.observer = null;
      }
      releaseTeaser(rec);
      releaseA11y(rec);
      if (rec.doc) removeStyle(rec.doc, STYLE_ID);
      rec.doc = null;
      rec.observedTarget = null;
    }

    function dropRecord(rec) {
      if (rec.observer) {
        rec.observer.disconnect();
        rec.observer = null;
      }
      rec.observedTarget = null;
      if (rec.onLoad) {
        rec.iframe.removeEventListener('load', rec.onLoad);
        rec.onLoad = null;
      }
      releaseFrameState(rec);
      rec.doc = null;
    }

    /* -- synchronous uncompaction the moment an open chat is observed -- */

    function clearCompactNow() {
      for (var i = 0; i < frames.length; i++) {
        var rec = frames[i];
        if (!rec.iframe.hasAttribute(COMPACT_ATTR)) continue;
        var frameDoc = sameOriginDoc(rec.iframe);
        if (!frameDoc || isOpen(frameDoc)) {
          rec.iframe.removeAttribute(COMPACT_ATTR);
        }
      }
    }

    function onFrameMutation() {
      if (destroyed) return;
      clearCompactNow();
      /* Reconcile known app states in the mutation microtask, before paint. */
      sync();
    }

    function observeFrame(rec, frameDoc) {
      var target = frameDoc.documentElement || frameDoc.body;
      if (!target) return;
      if (rec.observedTarget === target && rec.observer && rec.doc === frameDoc) return;
      if (rec.observedTarget && rec.observedTarget !== target) {
        releaseReplacedDocument(rec);
      } else if (rec.doc && rec.doc !== frameDoc) {
        releaseReplacedDocument(rec);
      } else if (rec.observer) {
        rec.observer.disconnect();
        rec.observer = null;
      }
      rec.doc = frameDoc;
      rec.observedTarget = target;
      var MO = win.MutationObserver;
      if (typeof MO !== 'function' && frameDoc.defaultView) {
        MO = frameDoc.defaultView.MutationObserver;
      }
      if (typeof MO !== 'function') return;
      rec.observer = new MO(onFrameMutation);
      rec.observer.observe(target, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: WATCHED_ATTRS
      });
    }

    /* -- single reconciliation pass -- */

    function sync() {
      if (destroyed) return;
      if (!root || !root.isConnected) {
        destroy();
        return;
      }
      if (rootMode === 'page' && !isScopedBody(root)) {
        destroy();
        return;
      }

      var found = doc.querySelectorAll('#bik-chat-root iframe, iframe#bik-chat-iframe');
      var seen = [];
      var i;
      for (i = 0; i < found.length; i++) {
        if (seen.indexOf(found[i]) === -1) seen.push(found[i]);
      }

      for (i = frames.length - 1; i >= 0; i--) {
        if (seen.indexOf(frames[i].iframe) === -1) {
          dropRecord(frames[i]);
          frames.splice(i, 1);
        }
      }

      var mobile = isMobile();

      for (i = 0; i < seen.length; i++) {
        var iframe = seen[i];
        var rec = frameRecord(iframe);
        var frameDoc = sameOriginDoc(iframe);

        if (!frameDoc) {
          /* Cross-origin: own nothing, leave chat usable. */
          releaseFrameState(rec);
          continue;
        }
        observeFrame(rec, frameDoc);

        if (!mobile) {
          releaseFrameState(rec);
          continue;
        }

        var parts = recognizeClosed(frameDoc, scopeToken());
        if (!parts) {
          /* Open, or markup we do not recognize: hands off. */
          releaseFrameState(rec);
          continue;
        }

        if (parts.proactive) {
          releaseFrameState(rec);
          dismissProactive(parts);
          continue;
        }

        ensureStyle(frameDoc, STYLE_ID, FRAME_CSS);
        if (parts.teaserAncestor) hideTeaser(rec, parts.teaserAncestor);
        else releaseTeaser(rec);
        applyA11y(rec, parts.avatarContainer);
        setCompact(iframe, true);
      }
    }

    /* -- lifecycle -- */

    function onMediaChange() {
      schedule();
    }

    function onHostMutation() {
      if (destroyed) return;
      schedule();
    }

    function onSectionUnload(event) {
      if (!root) return;
      var target = event && event.target;
      if (!target || target === doc) {
        destroy();
        return;
      }
      if (target === root || (target.contains && target.contains(root))) destroy();
    }

    function destroy() {
      if (destroyed) return;
      destroyed = true;
      if (rafId && typeof win.cancelAnimationFrame === 'function') {
        win.cancelAnimationFrame(rafId);
      }
      rafId = 0;
      for (var i = 0; i < frames.length; i++) dropRecord(frames[i]);
      frames.length = 0;
      if (hostObserver) {
        hostObserver.disconnect();
        hostObserver = null;
      }
      removeStyle(doc, STYLE_ID);
      if (mql) {
        if (typeof mql.removeEventListener === 'function') {
          mql.removeEventListener('change', onMediaChange);
        } else if (typeof mql.removeListener === 'function') {
          mql.removeListener(onMediaChange);
        }
        mql = null;
      }
      doc.removeEventListener('shopify:section:unload', onSectionUnload);
      root = null;
      if (win.__hhPdpChatAdapter && win.__hhPdpChatAdapter.__owner === api) {
        win.__hhPdpChatAdapter = null;
      }
    }

    var api = { sync: sync, schedule: schedule, destroy: destroy };

    function start() {
      if (win.__hhPdpChatAdapter) return win.__hhPdpChatAdapter;
      root = findOptedInRoot(doc);
      rootMode = root ? 'product' : null;
      if (!root) {
        root = findScopedBody(doc);
        rootMode = root ? 'page' : null;
      }
      if (!root) return null;
      if (typeof win.matchMedia !== 'function') return null;
      label = labelFor(root);
      mql = win.matchMedia(MOBILE_QUERY);
      if (typeof mql.addEventListener === 'function') {
        mql.addEventListener('change', onMediaChange);
      } else if (typeof mql.addListener === 'function') {
        mql.addListener(onMediaChange);
      }
      ensureStyle(doc, STYLE_ID, HOST_CSS);
      if (typeof win.MutationObserver === 'function') {
        hostObserver = new win.MutationObserver(onHostMutation);
        hostObserver.observe(doc.documentElement || doc.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: HOST_WATCHED_ATTRS
        });
      }
      doc.addEventListener('shopify:section:unload', onSectionUnload);
      api.__owner = api;
      win.__hhPdpChatAdapter = api;
      sync();
      return api;
    }

    api.start = start;
    return api;
  }

  function boot(win) {
    var adapter = create(win);
    return adapter.start() || adapter;
  }

  if (typeof window !== 'undefined' && window.document) {
    if (window.document.readyState === 'loading') {
      window.document.addEventListener('DOMContentLoaded', function () {
        boot(window);
      });
    } else {
      boot(window);
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { boot: boot, OPT_IN_ATTR: OPT_IN_ATTR };
  }
})();
